module.exports = __webpack_public_path__ + "static/media/rehab1.ffd0367f.jpg";